// extracted by mini-css-extract-plugin
module.exports =  {"list":"da51a739f7--list--BQoXm","list__item":"da51a739f7--list__item--IJv3t","list__item-mark":"da51a739f7--list__item-mark--mzQ3q"};